module.exports = __webpack_public_path__ + "static/media/fromage.13e8603b.svg";